import { render, staticRenderFns } from "./LabelHome.vue?vue&type=template&id=37cf30e1&"
import script from "./LabelHome.vue?vue&type=script&lang=js&"
export * from "./LabelHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports